import React, { useRef, useState } from 'react';
import garden1 from '../assets/images/Garden-5.webp';
import garden2 from '../assets/images/gurdon_6.webp';
import garden3 from '../assets/images/Garden-4.webp';
import crowd from '../assets/images/gurdon_5.webp';
import wedding from '../assets/images/Garden-5.webp';
import '../styles/gallery.css';

const images = [garden1, garden2, garden3, crowd, wedding];

const GardenGallery = ({ language }) => {
  const scrollRef = useRef(null);
  const [modalImage, setModalImage] = useState(null);

  const scroll = (dir) => {
    scrollRef.current.scrollBy({ left: dir === 'left' ? -400 : 400, behavior: 'smooth' });
  };

  return (
    <section className="gallery-wrapper py-5 bg-dark text-white">
      <div className="container">
<h2 className="fw-bold mb-4 text-center">
  {language === 'en' ? 'Garden Gallery' : 'የገነት ጋለሪ'}
</h2>        <div className="gallery-scroll-wrapper">
          <button className="scroll-btn left" onClick={() => scroll('left')}>&lt;</button>
          <div className="gallery-scroll" ref={scrollRef}>
            {images.map((img, i) => (
              <div className="gallery-image-wrapper" key={i} onClick={() => setModalImage(img)}>
                <img src={img} className="gallery-image" alt={`garden-${i}`} />
              </div>
            ))}
          </div>
          <button className="scroll-btn right" onClick={() => scroll('right')}>&gt;</button>
        </div>
      </div>

      {modalImage && (
        <div className="image-modal" onClick={() => setModalImage(null)}>
          <img src={modalImage} className="modal-img" alt="preview" />
          <button className="close-btn" onClick={() => setModalImage(null)}>×</button>
        </div>
      )}
    </section>
  );
};

export default GardenGallery;
